import React from 'react';
import { connect } from 'react-redux';
import ApplyModal from 'src/universal/components/Modal/Variations/ApplyModal';
import { getApplyModalData } from 'page_modules/compare/redux.js';
import styles from './__styles__/index.scss?modules';

const AmazonApplyModal = React.memo(({ modalDataList = [] }) => {
  return (
    <div className={styles.modalWrap}>
      {modalDataList.map((item, i) => {
        return (
          <ApplyModal
            key={`k${i}`}
            modalName={`apply_${item.cardName}`}
            data={item.modalData}
            isModalOpen={true}
          />
        );
      })}
    </div>
  );
});

const mapStateToProps = state => ({
  modalDataList: getApplyModalData(state)
});

export default connect(mapStateToProps)(AmazonApplyModal);
